



















import { Vue, Component } from "vue-property-decorator";
import NotificationOptions, {
  EnumNotificationType
} from "./model/notificationOptions";
@Component({
  name: "ui-notification"
})
export default class UiDialogComponent extends Vue {
  notificationsSuccess = new Array<NotificationOptions>();
  notificationsError = new Array<NotificationOptions>();
  notifications = new Array<NotificationOptions>();

  message = "";
  type = "";
  heightEl = 75;
  offset = 16;
  getClassByType(type: EnumNotificationType) {
    switch (type) {
      case EnumNotificationType.Error:
        return "notification-error";
      case EnumNotificationType.Success:
        return "notification-success";
    }
  }
  getIconClassByType(type: EnumNotificationType) {
    switch (type) {
      case EnumNotificationType.Error:
        return "icon-close";
      case EnumNotificationType.Success:
        return "icon-check";
    }
  }
  getAddedElementHeight(type: EnumNotificationType): number {
    const el = this.$refs.wrapper as HTMLElement;
    const childs = el.querySelectorAll(".notification");
    if (childs && childs.length > 0) {
      return childs[childs.length - 1].clientHeight + this.offset;
    }
    return 0;
  }
  show(ev: NotificationOptions): void {
    this.notifications.push(ev);
    setTimeout(() => {
      this.changePositionArray(ev, this.getAddedElementHeight(ev.type));
    });
    setTimeout(this.removeArray.bind(this, ev), ev.timeOut);
  }
  changePositionArray(ev: NotificationOptions, height: number): void {
    this.notifications.filter(x => x !== ev).map(x => (x.top += height));
  }
  removeArray(notification: NotificationOptions): void {
    this.notifications = this.notifications.filter(x => x !== notification);
  }
}
